export const simpleTable = [
	{id: 14, name: 'Item 14', description: 'Desc 14'},
	{
		id: 2,
		name: 'Item 2Item 2Item 2Item 2Item 2Item 2Item 2Item 2Item 2Item 2Item 2',
		description:
		'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
	},
	{id: 3, name: 'item 3', description: 'Desc 3'},
	{id: 4, name: 'Item 4', description: 'Desc 4'},
	{id: 7, name: 'AAAA', description: 'bbbbbbb'},
	{id: 5, name: 'item 5', description: 'Desc 5'},
	{id: 6, name: '6', description: 'Desc 6'},
	{id: 16, name: '[Item 16', description: 'Desc 16'},
	{id: 8, name: 'AAAA', description: 'ccccccc'},
	{id: 10, name: 'Item 10', description: 'Desc 10'},
	{id: 18, name: 'Item 18', description: 'Desc 18'},
	{id: 1, name: 'Item 1', description: 'Desc 1'},
	{id: 12, name: 'Item 12', description: 'Desc 12'},
	{id: 13, name: 'AAAA', description: 'aaaaaaaa'},
	{id: 9, name: 'Item 9', description: 'Desc 9'},
	{id: 11, name: 'Item 11', description: 'Desc 11'},
	{id: 15, name: 'Item 15', description: 'Desc 15'},
	{id: 17, name: 'Item 17', description: 'Desc 17'},
	{id: 19, name: 'Item 19', description: 'Desc 19'},
	{id: 20, name: 'Item 20', description: 'Desc 20'},
	{id: 21, name: 'Item 21', description: 'Desc 21'},
	{id: 22, name: 'Item 22', description: 'Desc 22'},
	{id: 23, name: 'Item 23', description: 'Desc 23'},
	{id: 24, name: 'Item 24', description: 'Desc 24'},
	{id: 25, name: 'Item 25', description: 'Desc 25'},
	{id: 26, name: 'Item 26', description: 'Desc 26'},
	{id: 27, name: 'Item 27', description: 'Desc 27'},
	{id: 28, name: 'Item 28', description: 'Desc 28'},
	{id: 29, name: 'Item 29', description: 'Desc 29'},
	{id: 30, name: 'Item 30', description: 'Desc 30'}
];

export const groups = [
	{
		groupLabel: 'group 1',
		data: simpleTable
	},
	{
		groupLabel: 'group 2',
		data: simpleTable
	},
	{
		groupLabel: 'group 3',
		data: simpleTable
	}
];
